export class FullServicePricingType {
    ID: number;
    Name: string;
}

export default FullServicePricingType;